export default ({
    code,
    name,
    text,
    isStatic,
    isActive
}) => ({
    code,
    name,
    text,
    isStatic,
    isActive
});